import * as React from 'react'
import DeleteTaskIcon from './delete-task.svg'

interface RemoveProps {
  update?: (filters: any) => void
  onClick?: () => void
}
export const Remove = (props: RemoveProps) => {
  const remove = () => props.update(undefined)
  return (
    <DeleteTaskIcon
      className="float-right ml-auto cursor-pointer mr-8 text-obscure-old active:text-main-old hover:text-error-old "
      onClick={props.onClick ?? remove}
    />
  )
}

export const Separator = () => (
  <div className="w-16 h-24 flex justify-center items-center">»</div>
)
